import React from 'react'
import { useState } from 'react';
import './stylesheets/SearchForm.css';

function SearchForm({ onSearch }){
    const [searchTerm, setSearchTerm] = useState("");
    const handleSubmit = async (event) => {
        event.preventDefault();
        onSearch(searchTerm);
    }
    return (
        <div id="SearchForm">
            <form onSubmit={handleSubmit} >
                <label>
                    <div className="input-group mb-3">
                        <input  
                            id='SubmitField'
                            type="text" 
                            value={searchTerm}
                            className="form-control" 
                            placeholder="" 
                            aria-describedby="basic-addon2"
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <div className="input-group-append">
                            <input  
                                type="submit" 
                                className="btn btn-primary" 
                                id="SearchButton" 
                                value="Search" 
                            />
                        </div>
                    </div>
                </label>
            </form>
        </div>
    )
}

export default SearchForm;